import React from 'react';
import { Dots, Spinner } from 'react-activity';
// import 'react-activity/dist/react-activity.css';
import * as Colors from '../styles/colors';

const Loading = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '100px' }}>
      <Dots size={50} color={Colors.flBlue} />
    </div>
  )
}

export const RowLoading = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '10px' }}>
      <Dots size={50} color={Colors.flBlue} />
    </div>
  )
}

export const MediumRowLoading = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '10px' }}>
      <Dots size={35} color={Colors.flBlue} />
    </div>
  )
}

export const SmallRowLoading = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '10px' }}>
      <Dots size={25} color={Colors.flBlue} />
    </div>
  )
}

export const FileLoading = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '0px' }}>
      File Downloading<br/>
      <Dots size={10} color={Colors.flBlue} />
    </div>
  )
}

export const FileSpinner = ({style}) => {
  return (
    <div style={{ ...style, marginTop: '0px', display: 'inline-flex' }}>
      File Downloading
      <Spinner size={10} color={Colors.flBlue}
        style={{marginLeft: '5px', marginTop: '5px'}}
      />
    </div>
  )
}

export default Loading;
